import { ToastProps } from "../../types";
import { MyToast, CrossIcon } from "./Toast.styles";

function Toast(props: ToastProps) {
  const { message, type, resetToast } = props;
  return (
    <MyToast type={type}>
      <p>{message}</p>
      <CrossIcon onClick={resetToast}>x</CrossIcon>
    </MyToast>
  );
}

export default Toast;
